import type { ReactElement } from 'react';
import type { CustomerContactDTO } from '../../../server/dto/customer-contact-dto.ts';
import { api } from '../../../utils/api.ts';
import { SearchSelect } from './search-select.tsx';

export type ContactPersonInputProps = {
    customerId: string | undefined;
    disabled?: boolean;
    onChange?: (id: string) => void;
    placeholder?: string;
    value?: string;
};

export function ContactPersonInput({
    customerId,
    disabled,
    onChange,
    placeholder,
    value,
}: ContactPersonInputProps): ReactElement {
    const { data: contactList, isLoading: isContactListLoading } =
        api.platoUser.getManyCustomerContact.get.useQuery(
            { customerId: customerId ?? '' },
            { enabled: !!customerId },
        );

    return (
        <SearchSelect
            disabled={disabled}
            items={contactList}
            idSelector={(x) => x.contactId}
            isLoading={isContactListLoading}
            onSelectedIdChange={onChange}
            placeholder={placeholder}
            renderItem={getContactName}
            selectedId={value}
            textSelector={getContactName}
        />
    );
}

function getContactName(contact: CustomerContactDTO): string {
    return [contact.firstName, contact.lastName]
        .map((x) => x?.trim())
        .filter(Boolean)
        .join(' ');
}
